module.exports = __webpack_public_path__ + "static/media/DSCF9517.107d55f7.jpg";